
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/word-to-pdf",
      function () {
        return require("private-next-pages/word-to-pdf.js");
      }
    ]);
  